export const IMAGE_BASE_URL = "https://alpinac-trailmaps.s3.amazonaws.com/"
export const IMAGE_THUMB_BASE_URL = "https://alpinac-trailmaps.s3.amazonaws.com/thumb/"
